import React from 'react';
import BreadcrumbClassContainer from '../../Componant/Bonus-Ui/Breadcrumb';

const BreadcrumbClass = () => {
  return (
    <div className='page-body'>
      <BreadcrumbClassContainer />
    </div>
  );
};

export default BreadcrumbClass;
